// ============================================================
// NETWORK CONFIGURATION
// ============================================================
// Change ACTIVE_NETWORK to switch between mainnet and testnet.
// Users NEVER see which one is active - this is code-side only.
// ============================================================
//
//   mainnet  = opBNB Mainnet (chainId 204)
//   testnet  = opBNB Testnet (chainId 5611)
//
// ============================================================

// Set to 'mainnet' or 'testnet'
export const ACTIVE_NETWORK = 'mainnet';

const NETWORKS = {
  // opBNB Mainnet
  mainnet: {
    chainId: 204,
    chainIdHex: '0xCC',
    name: 'opBNB',
    rpcUrls: [
      'https://opbnb-mainnet-rpc.bnbchain.org',
      'https://opbnb-rpc.publicnode.com',
      'https://opbnb.publicnode.com',
      
    ],
    blockExplorerUrls: ['https://opbnbscan.com'],
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    }
  },
  // opBNB Testnet
  testnet: {
    chainId: 5611,
    chainIdHex: '0x15EB',
    name: 'opBNB',
    rpcUrls: [
      'https://opbnb-testnet-rpc.bnbchain.org',
      'https://opbnb-testnet.publicnode.com'
    ],
    blockExplorerUrls: ['https://opbnb-testnet.bscscan.com'],
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    }
  }
};

export const CURRENT_NETWORK = NETWORKS[ACTIVE_NETWORK];

export const getNetworkParams = () => ({
  chainId: CURRENT_NETWORK.chainIdHex,
  chainName: CURRENT_NETWORK.name,
  nativeCurrency: CURRENT_NETWORK.nativeCurrency,
  rpcUrls: CURRENT_NETWORK.rpcUrls,
  blockExplorerUrls: CURRENT_NETWORK.blockExplorerUrls
});
